import { NETWORK_REQUEST_PATH } from '../constants'
import { getObjectUtil } from 'packages/src'

function getActionTypeNetworkRequestUtil (request) {
  return (
    getObjectUtil(request, NETWORK_REQUEST_PATH.ACTION_TYPE)
  )
}

export { getActionTypeNetworkRequestUtil }
